const VERSION = 0

const MEAS_DURATION = 30

const STATUS = Object.freeze({
  OK: 0,
  UNKNOWN_CMD: 1,
  OUT_OF_RANGE: 2,
  EOF: 3,
})

const MESSAGE_TYPES = Object.freeze({
  GET_INFO: 0,
  GET_STAT: 1,
  MEAS_CTRL: 2,
  MEAS_RES: 3,
  GET_FILE: 4,
  INIT_LIC: 5,
  UPD_LIC: 6,
})

const MEAS_TYPE = Object.freeze({
  CALIBRATION: 0,
  MEASUREMENT: 1,
})

const MEAS_CHANNEL = Object.freeze({
  MIC_1: 0,
  MIC_2: 1,
})

const MEAS_CTRL = Object.freeze({
  OFF: 0,
  ON: 1,
})

const FILE_TYPE = Object.freeze({
  SPEC: 0,
  CAVI: 1,
  FREQ: 2,
  APM: 3,
})
export type FILE_TYPE = typeof FILE_TYPE[keyof typeof FILE_TYPE];

const GET_INFO = Object.freeze({
  v: VERSION,
  i: MESSAGE_TYPES.GET_INFO
})

const GET_STAT = Object.freeze({
  v: VERSION,
  i: MESSAGE_TYPES.GET_STAT
})

const MEAS_CTRL_ON = Object.freeze({
  v: VERSION,
  i: MESSAGE_TYPES.MEAS_CTRL,
  m: MEAS_CTRL.ON,
  c: MEAS_CHANNEL.MIC_1,
  d: MEAS_DURATION,
  t: MEAS_TYPE.MEASUREMENT,
})

const MEAS_CTRL_OFF = Object.freeze({
  v: VERSION,
  i: MESSAGE_TYPES.MEAS_CTRL,
  m: MEAS_CTRL.OFF,
  c: MEAS_CHANNEL.MIC_1,
  d: MEAS_DURATION,
  t: MEAS_TYPE.MEASUREMENT,
})

const MEAS_RES = Object.freeze({
  v: VERSION,
  i: MESSAGE_TYPES.MEAS_RES,
})

const MAXIMUM_FILE_BLOCKS = Object.freeze<Record<FILE_TYPE, number>>({
  [FILE_TYPE.SPEC]: 85,
  [FILE_TYPE.CAVI]: 85,
  [FILE_TYPE.FREQ]: 3,
  [FILE_TYPE.APM]: 3,
})

// Expected block counts for progress estimation (actual EOF block + 1).
const EXPECTED_FILE_BLOCKS = Object.freeze<Record<FILE_TYPE, number>>({
  [FILE_TYPE.SPEC]: 19,
  [FILE_TYPE.CAVI]: 19,
  [FILE_TYPE.FREQ]: 1,
  [FILE_TYPE.APM]: 1,
})

type GET_FILE_PARAMS = { type: FILE_TYPE, block: number }
const GET_FILE = (params: GET_FILE_PARAMS) => Object.freeze({
  v: VERSION,
  i: MESSAGE_TYPES.GET_FILE,
  t: params.type,
  b: params.block,
})

type INIT_LIC_PARAMS = { date: string }
const INIT_LIC = (params: INIT_LIC_PARAMS) => Object.freeze({
  v: VERSION,
  i: MESSAGE_TYPES.INIT_LIC,
  d: params.date,
})

type UPD_LIC_PARAMS = {
  serial: string,
  date: string,
  durationMonths: number,
  licenseCounter: number,
  signature: string,
}
const UPD_LIC = (params: UPD_LIC_PARAMS) => Object.freeze({
  v: VERSION,
  i: MESSAGE_TYPES.UPD_LIC,
  S: params.serial,
  d: params.date,
  D: params.durationMonths,
  L: params.licenseCounter,
  C: params.signature,
})

export default {
  VERSION,
  STATUS,
  GET_INFO,
  GET_STAT,
  MEAS_CTRL_ON,
  MEAS_CTRL_OFF,
  MEAS_DURATION,
  MEAS_RES,
  FILE_TYPE,
  MAXIMUM_FILE_BLOCKS,
  EXPECTED_FILE_BLOCKS,
  GET_FILE,
  INIT_LIC,
  UPD_LIC,
}
